module.exports = __webpack_public_path__ + "static/media/water.af6cbc92.jpg";